var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16016 7.16797L0.855469 1.86328C0.727865 1.73568 0.664062 1.58073 0.664062 1.39844C0.664062 1.21615 0.727865 1.0612 0.855469 0.933594L1.45703 0.332031C1.58464 0.204427 1.73958 0.140625 1.92188 0.140625C2.10417 0.122396 2.25911 0.177083 2.38672 0.304688L6.625 4.54297L10.8633 0.304688C10.9909 0.177083 11.1458 0.122396 11.3281 0.140625C11.5104 0.140625 11.6654 0.204427 11.793 0.332031L12.3945 0.933594C12.5221 1.0612 12.5859 1.21615 12.5859 1.39844C12.5859 1.58073 12.5221 1.73568 12.3945 1.86328L7.08984 7.16797C6.96224 7.3138 6.80729 7.38672 6.625 7.38672C6.44271 7.38672 6.28776 7.3138 6.16016 7.16797Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabArrowDown);
export default __webpack_public_path__ + "static/media/tab-arrow-down.dc8c2e0744f6cfddebb69bee19b025c7.svg";
export { ForwardRef as ReactComponent };